import { isPathRestrictedForCountry } from '@/utils/tile-country-visibility';

interface DestinationTopic {
  path: string;
}

interface ResolveFallbackLinkParams {
  destinationTopics: DestinationTopic[] | null | undefined;
  country: string | null | undefined;
  fallbackLink: string | null | undefined;
  localeIndexPath: string;
}

// When a tile CTA's internal-link destination is restricted in the visitor's country,
// the visitor must be routed away from the (blocked) destination. We prefer the
// CMS-authored fallback link; when none is configured we fail safe to the locale index.
// Returns null when the destination is not restricted, so the caller keeps the original href.
export function resolveFallbackLink({
  destinationTopics,
  country,
  fallbackLink,
  localeIndexPath,
}: ResolveFallbackLinkParams): string | null {
  if (!isPathRestrictedForCountry(destinationTopics, country)) {
    return null;
  }

  return fallbackLink || localeIndexPath;
}
